import React from 'react';

const StepControls = ({ nextStep, onContinue, disableContinue, error }) => {
  return (
    <div className="onboarding-footer">
      {error && <div class="onboarding-error mb2">{error}</div>}
      <button
        onClick={onContinue || nextStep}
        className="button button-red button-stretch button-small"
        disabled={disableContinue}
      >
        Continue
      </button>
      <button className="button button-small button-skip" onClick={nextStep}>
        Skip
      </button>
    </div>
  );
};

const StepContainer = ({
  heading,
  subheading,
  nextStep,
  onContinue,
  disableContinue,
  children,
  error,
}) => (
  <>
    <div className="onboarding-content">
      <h2 className="onboarding-heading">{heading}</h2>
      <p className="mt2">{subheading}</p>
      {children}
    </div>
    <StepControls
      nextStep={nextStep}
      onContinue={onContinue}
      disableContinue={disableContinue}
      error={error}
    />
  </>
);

export default StepContainer;
